// extracted by mini-css-extract-plugin
export default {"wrapper":"ap","form":"bp","option":"cp","radio":"dp","success":"ep","contest":"fp"};